import { appConfig } from '@/lib/app-config';

/** Roles that can approve team leave/claims and view team attendance on mobile. */
export function canApproveTeam(role: string): boolean {
  if (appConfig.selfServiceOnly) {
    return false;
  }

  return role === 'MANAGER' || role === 'HR_ADMIN' || role === 'SYSTEM_ADMIN';
}

export function canViewTeamAttendance(role: string): boolean {
  return canApproveTeam(role);
}
